var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.970941 10.6602L0.0237043 14.7483C-0.00897214 14.8977 -0.00785197 15.0526 0.0269829 15.2015C0.0618178 15.3505 0.129488 15.4898 0.225049 15.6092C0.32061 15.7287 0.441648 15.8253 0.579322 15.892C0.716995 15.9587 0.867826 15.9937 1.0208 15.9947C1.09207 16.0019 1.16389 16.0019 1.23517 15.9947L5.34817 15.0474L13.2451 7.18038L8.83799 2.7832L0.970941 10.6602Z",
    fill: "#6AC982"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7279 3.24184L12.7865 0.300417C12.5931 0.108011 12.3314 0 12.0586 0C11.7858 0 11.5241 0.108011 11.3307 0.300417L9.6955 1.93565L14.0977 6.33781L15.7329 4.70258C15.8286 4.6064 15.9044 4.49229 15.9559 4.36679C16.0075 4.24128 16.0338 4.10685 16.0333 3.97117C16.0328 3.8355 16.0056 3.70124 15.9532 3.57609C15.9008 3.45095 15.8242 3.33736 15.7279 3.24184Z",
    fill: "#6AC982"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ba813fa6f79d2883d40d112626202cc3.svg";
export { ForwardRef as ReactComponent };